import { LsStoreKey } from '@/types';
import { getDataFromLs } from '@/helpers/localStorage';

export const getUserUniqueQueryKey = (name: string) => `${name}_${getDataFromLs(LsStoreKey.LastSignedUserId) || ''}`;
